import React, { useEffect } from 'react';
import Bredcom from '../../Bredcom/Main';
import Header from '../../headerone/Main';
import Blog from '../../menhome/Blog';
import Event from '../../menhome/Event';
import Newlast from '../../menhome/Newlast';
import First from '../menstandards/First';



function Main() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Standards";
  }, [])

  return (
    <>
         <Header/>

         <div className="page-wrapper">
          <Bredcom 
            subtitle="Home"
            title="professional standards"
            subtitledown="Professional Standards "
           />
            <First/>
            <Event/>
            <Blog/>
            <Newlast/>
         </div>
    </>
  )
}

export default Main